import React from 'react'

const Thankyou = () => {
  return (
      <div className="flex items-center justify-center h-[58dvh] bg-blue-50">
        <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md text-center">
          <h1 className="text-4xl font-semibold text-blue-600">Thank You!</h1>
          <p className="mt-4 text-xl text-sky-500">
            You have Successfully Registered for the Training.
          </p>
          <div className="mt-4">
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition" onClick={() => window.location.href = '/'}>
              Go Home
            </button>
          </div>
        </div>
      </div>
  );
}

export default Thankyou